import { Component } from '@angular/core';
import { ProgressBarService } from 'src/app/core/services/progress-bar.service';

@Component({
  selector: 'digi-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss'
})
export class ProgressBarComponent {
  constructor(public progressBarService: ProgressBarService) {}
}
